/**
 * Keeps Autocomplete helper/error text associated with the text field after
 * moving the visible copy outside the menu anchor.
 *
 * Material Web syncs slotted `#description` from supporting/error text whenever
 * `count` (value length) changes, which clears any text we set there. Call this
 * again after input/`query` updates so the announcement text stays put.
 */
export function syncAutocompleteFieldA11y(
  host: HTMLElement | null,
  descriptionText: string,
  descriptionId: string
): void {
  if (!host) return;

  const shadowRoot = host.shadowRoot;
  const shadowInput = shadowRoot?.querySelector("input");
  shadowInput?.setAttribute("autocomplete", "off");

  const shadowDescription = shadowRoot?.querySelector("#description");
  if (shadowDescription) {
    shadowDescription.textContent = descriptionText;
    return;
  }

  // Vitest LitTextField mock / light-DOM fields: associate the visible node.
  const lightInput = host instanceof HTMLInputElement ? host : host.querySelector("input");
  if (!lightInput) return;

  lightInput.setAttribute("autocomplete", "off");
  if (descriptionText) {
    lightInput.setAttribute("aria-describedby", descriptionId);
  } else {
    lightInput.removeAttribute("aria-describedby");
  }
}
